import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../_services/services/loader.service';
import { finalize } from 'rxjs/operators';
import { HttpContextConfig } from '../models/http-context-config';

export const CONFIG = new HttpContextToken<HttpContextConfig>(
  () => new HttpContextConfig()
);
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  service_count = 0;
  isLoading: any;
  constructor(private readonly loaderService: LoaderService) {}

  // metodo che intercetta le chiamate e gestisce il loader di caricamento
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.context.get(CONFIG)) {
      let config = req.context.get(CONFIG);
      if (!config.noSpinner) this.loaderService.setLoading(true, req.url);
    }

    return next.handle(req).pipe(
      finalize(() => {
        this.loaderService.setLoading(false, req.url);
      })
    );
  }
}

export const loaderInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
];
